module.exports = __webpack_public_path__ + "img/Ranger.5111cd27.png";